import React from 'react';
import { Link } from 'react-router-dom';
import { IGeneratedCase } from '../../..';
import envelopeIcon from '../../../../../../images/envelope.svg';
import uploadDoc from '../../../../../../images/upload.svg';
import upLoadIcon from '../../../../../../images/file-arrow-up.svg';
import { OverviewDocuments } from '../documents';
import { OverviewLetters } from '../letters';
import { MultipleCardContainer } from '../../../components/tw-components';

type Props = {
  claim: IGeneratedCase;
  headerLink?: string;
  documentCount: number | null;
  letterCount: number | null;
  setDocumentCount: React.Dispatch<React.SetStateAction<number | null>>;
  setLetterCount: React.Dispatch<React.SetStateAction<number | null>>;
};

const formatCountLabel = (count: number | null, singular: string) => {
  const value = count ?? 0;
  const label = value === 1 ? singular : `${singular}s`;
  return `${value} ${label}`;
};

export const DocsAndLetters = ({
  claim,
  headerLink,
  documentCount,
  letterCount,
  setDocumentCount,
  setLetterCount,
}: Props) => {
  return (
    <MultipleCardContainer id="docs-and-letters-card">
      <div className="tw-overflow-hidden tw-bg-white">
        <div className="tw-bg-unm-mixed-bg">
          <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-text-md tw-text-unm-adhoc2">
            <span className="tw-flex tw-items-center tw-gap-2">
              <img
                src={envelopeIcon}
                alt=""
                aria-hidden="true"
                className="tw-h-3 tw-w-[20.8px] tw-shrink-0 tw-object-contain"
              />
              <span>From Unum</span>
            </span>
            <span>{formatCountLabel(letterCount, 'letter')}</span>
          </div>
          <div className="tw-bg-white">
            <OverviewLetters
              claim={claim}
              headerLink={headerLink}
              setLetterCount={setLetterCount}
            />
          </div>
        </div>

        <div className="tw-bg-unm-mixed-bg">
          <div className="tw-flex tw-items-center tw-justify-between  tw-px-4 tw-py-3 tw-text-md tw-text-unm-adhoc2">
            <span className="tw-flex tw-items-center tw-gap-2">
              <img
                src={upLoadIcon}
                alt=""
                aria-hidden="true"
                className="tw-h-4 tw-w-[20.8px] tw-shrink-0 tw-object-contain"
              />
              <span>Uploaded by you</span>
            </span>
            <span>{formatCountLabel(documentCount, 'document')}</span>
          </div>
          <div className="tw-bg-white">
            <OverviewDocuments
              claim={claim}
              headerLink={headerLink}
              setDocumentCount={setDocumentCount}
            />
          </div>
        </div>

        <div
          className="tw-flex justify-start tw-items-center tw-justify-between tw-gap-3  tw-bg-white tw-px-5 tw-py-4
            tw-border-t tw-border-solid tw-border-0 tw-border-unm-border1"
        >
          <Link to="/app/upload" className="tw-w-full">
            <button
              type="button"
              className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-border-2 tw-border-solid tw-border-unm-interactive01-400 tw-bg-white tw-py-3 tw-px-6 tw-text-base tw-font-semibold tw-text-unm-interactive01-400"
            >
              <img
                src={uploadDoc}
                alt=""
                aria-hidden="true"
                className="tw-h-4 tw-w-4 tw-shrink-0 tw-object-contain"
              />
              <span>Upload Document</span>
            </button>
          </Link>
          {headerLink && (
            <Link
              to={headerLink}
              className="tw-whitespace-nowrap tw-text-sm tw-font-semibold tw-text-unm-interactive01-400"
            >
              View All
            </Link>
          )}
        </div>
      </div>
    </MultipleCardContainer>
  );
};
